import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { CheckList } from '@work4all/models/lib/Classes/CheckList.entity';
import { SdObjType } from '@work4all/models/lib/Enums/SdObjType.enum';

const CREATE_CHECKLIST_FROM_TEMPLATE_MUTATION = gql`
  mutation CreateChecklistFromTemplate(
    $code: Int!
    $textSuffix: String
    $sdObjType: SdObjType
    $sdObjCode: Int
    $projectCode: Int
  ) {
    createChecklistFromTemplate(
      code: $code
      textSuffix: $textSuffix
      sdObjType: $sdObjType
      sdObjCode: $sdObjCode
      projectCode: $projectCode
    ) {
      code
    }
  }
`;

interface Variables {
  code: number;
  textSuffix: string;
  sdObjType?: SdObjType;
  sdObjCode?: number;
  projectCode?: number;
}

interface Response {
  createChecklistFromTemplate: {
    code: number;
  };
}

export interface CreateChecklistFromTemplateProps {
  id: number;
  customerId?: number;
  projectId?: number;
}

export const useCreateChecklistFromTemplate = () => {
  const [mutate] = useMutation<Response, Variables>(
    CREATE_CHECKLIST_FROM_TEMPLATE_MUTATION
  );

  return useCallback(
    async ({
      id,
      customerId,
      projectId,
    }: CreateChecklistFromTemplateProps): Promise<CheckList> => {
      const variables: Variables = {
        code: id,
        textSuffix: ' (2)',
        projectCode: projectId,
      };

      if (customerId) {
        variables.sdObjCode = customerId;
        variables.sdObjType = SdObjType.KUNDE;
      }

      const response = await mutate({
        variables,
      });

      return {
        id: response.data?.createChecklistFromTemplate.code,
      };
    },
    [mutate]
  );
};
